import Component from './component';

Component.defaultProps = {
    className: null,
    width: null,
    height: null,
};
export default Component;
